module.exports = __webpack_public_path__ + "img/mobile-elbow-3_52x70.f23f6cbc.png";